import { Injectable } from '@angular/core';
import { Brand, BrandDomain, BrandLogos } from '../model/brand.model';
import { resolveActiveBrand } from './brand-resolver';

/**
 * The single in-app point for the active brand's identity. The brand is resolved
 * once from the request host at construction (see resolveActiveBrand); components
 * read the name, logos and help links from here instead of hard-coding "Frankli".
 */
@Injectable({ providedIn: 'root' })
export class BrandService {
  readonly brand: Brand = resolveActiveBrand();

  get name(): string {
    return this.brand.name;
  }

  get logos(): BrandLogos {
    return this.brand.logos;
  }

  get domain(): BrandDomain {
    return this.brand.domain;
  }

  /** Builds an absolute help-centre URL for a path, from the brand's help domain. */
  helpUrl(path = ''): string {
    const base = this.brand.domain.help.replace(/\/+$/, '');
    if (!path) {
      return base;
    }
    return `${base}/${path.replace(/^\/+/, '')}`;
  }
}
